<template>
  <div
    class="border rounded-lg p-3 w-full cursor-text bg-white"
    :class="active ? 'border-brown' : 'border-bordergray'"
    @click="$emit('activate')"
  >
    <div class="flex items-center w-full">
      <p class="pr-2 text-brown flex-shrink-0">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="11" cy="11" r="7"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
      </p>
      <div class="top-search-chips">
        <span v-for="chip in chips" :key="chip.key" class="top-search-chip">
          {{ chip.label }}
          <button
            type="button"
            class="top-search-chip-remove"
            :aria-label="chip.label + 'を解除'"
            @click.stop="$emit('removeChip', chip)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </span>
        <input
          ref="input"
          type="text"
          class="top-search-chips-input outline-none bg-transparent"
          :value="keyword"
          :placeholder="chips.length > 0 ? 'キーワード' : 'エリア・キーワード・絞り込み'"
          autocomplete="off"
          :readonly="readonly"
          @input="$emit('update:keyword', $event.target.value)"
          @focus="$emit('activate')"
          @compositionstart="$emit('compositionstart')"
          @compositionend="$emit('compositionend')"
          @keydown.enter="$emit('enter', $event)"
          @keydown.esc="$emit('escape')"
        />
      </div>
      <button
        v-if="chips.length > 0 || keyword"
        type="button"
        class="pl-2 text-gray flex-shrink-0"
        aria-label="条件をすべてクリア"
        @click.stop="$emit('clear')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
// Keyword input with the selected conditions rendered as removable chips.
// Used once in the search form and once more at the top of the full-screen panel on mobile.
export default {
  props: {
    chips: {
      type: Array,
      required: true,
    },
    keyword: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    // Readonly inputs still receive taps (so the panel can open) but do not raise the on-screen keyboard.
    readonly: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
